// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  padding: 0;
}

body {
  font-family: "Manrope", sans-serif;
  width: 100%;
  display: block !important;
  background: white !important;
  overflow-x: hidden;
}
.card {
  padding: 0;
}

.width-full-page {
  width: 80%;
  /* z-index: 1; */
}

.width-full-page-product {
  width: 70%;
}

.mini-height-div {
  min-height: 70vh;
  align-content: center;
}

.card-head-width {
  width: 80%;
}
@media (max-width: 768px) {
  .width-full-page {
    width: 100%;
    padding: 2%;
  }
  .width-full-page-product {
    width: 100%;
    padding: 2%;
  }
  .reverse-display {
    display: flex;
    flex-direction: column-reverse;
  }
}

/* -----------------------------  render pages style  -------------------------------- */
.bg-green-custom {
  background-color: #ecfff3;
}
.span-with-green {
  color: #28af4b !important;
}
.span-with-green-mail {
  color: #28af4b;
  font-weight: 700;
  font-family: "Manrope", sans-serif;
}

.line-span {
  width: 100%;
  position: relative;
}
.line-div {
  width: 100%;
  border-bottom: 1.5px solid #707070;
  position: absolute;
  bottom: 7px;
}

.line-div-max-length {
  width: 100%;
  border-bottom: 0.5px solid #707070a2;
  position: absolute;
  bottom: 7px;
  max-width: 150px;
}

/* --------------------------------- Headings ------------------------------------------- */
.heading-pages {
  font-family: "Poppins", sans-serif;
  /* line-height: 60px; */
  font-weight: 700;
  font-size: 30px;
  text-align: center;
  color: #333132;
}
.sub-div-headings {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 20px;
  text-wrap: nowrap;
}
.sub-div-modal-headings {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 20px;
}
.inner-text-heading {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #333132;
}

.inner-text-heading-two {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #333132;
}

.inner-text-heading-three {
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #707070;
}

.inner-text-content-three-color {
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #333132;
}

.inner-text-heading-four {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #333132;
}

.inner-text-heading-address {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #333132;
}

/* --------------------------------- Headings ------------------------------------------- */

/* ------------------------------------- inner content  ---------------------------------------- */

.sub-text-pages {
  font-size: 16px;
  color: #333132;
  font-weight: 700;
  font-family: "Manrope", sans-serif;
}
.inner-text-content {
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #333132;
}

.inner-text-content-two {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #333132;
}

.inner-text-content-three {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #333132;
}

.inner-text-content-four {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #707070;
}

.inner-text-content-five {
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #333132;
}

.inner-text-content-six {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #707070;
}

.inner-text-content-seven {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #333132;
}

.inner-text-content-five-font-12 {
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #333132;
}
.font-color-gray {
  color: #747373;
}

.one-line-headings {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ------------------------------------- inner content  ---------------------------------------- */

.green-button-style {
  background-color: #28af4b;
  color: white;
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  border-radius: 5px;
}
.green-transparnt-button-style {
  background-color: transparent;
  color: #28af4b;
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  border-radius: 5px;
  outline: 1px solid #28af4b;
}

.green-button-style:hover {
  border: 1px solid #28af4b;
}

.list-about-us {
  list-style-position: outside;
}

.list-about-us li {
  padding-top: 40px;
}

.background-light-green {
  background-color: #ecfff3;
}

.background-light-white {
  background-color: #f9f9f9;
}

.card-howitswork {
  border: 0.5px solid #eeeeee !important;
  box-shadow: none !important;
}

.number-div-height {
  height: 75px;
}
.card-number-head {
  background-color: #28af4b;
  padding: 10px;
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: 26px;
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  border-radius: 50%;
  color: white;
}

.accordion-custom {
  --bs-accordion-active-color: #28af4b !important;
  --bs-accordion-active-bg: none !important;
  border-bottom: none;
  --bs-accordion-btn-focus-box-shadow: none !important;
}

.product-custom-food {
  --bs-accordion-border-width: none !important;
  .accordion-header {
    /* border-bottom: 1px solid #eeeeee; */
    border-top: 1px solid #eeeeee;
  }
}
.food-list .accordion-button:not(.collapsed) {
  box-shadow: none;
}
/* --------  card hover  ------------- */

.content-fishcard {
  pointer-events: none;
  transition: all 0.4s;
  /* z-index: 1; */
}

.card-hghlght {
  pointer-events: auto;
  transform: scale(1);
  transition: all 0.4s;
  margin-top: 8px;
  height: 100%;
}

.card-hghlght:hover {
  opacity: 1;
  transform: scale(1.08);
}

.content-fishcard:hover .card-hghlght:not(:hover) {
  opacity: 0.5;
  transform: scale(0.9);
}

/* ------------reverse ------- */

.card-hghlght-reverse {
  pointer-events: auto;
  transform: scale(1);
  transition: all 1s;
  /* margin-top: 8px; */
  height: 100%;
  border-bottom-right-radius: 20px;

  .card-body {
    padding: 0px;
  }
}

.card-hghlght-reverse:hover {
  opacity: 1;
  transform: scale(1.05);
  box-shadow: 0 1px 2px 0 #eeeeee, 0 1.5px 5px 0 #eeeeee;
}

.content-fishcard-reverse:hover .card-hghlght-reverse:not(:hover) {
  opacity: 0.5;
  transform: scale(0.9);
}

.card-coupon-reverse {
  pointer-events: auto;
  transform: scale(1);
  transition: all 1s;
  height: 100%;
  border: none;
}

.card-coupon-reverse:hover {
  opacity: 1;
  transform: scale(0.95);
  box-shadow: 0 1px 2px 0 #eeeeee, 0 1.5px 5px 0 #eeeeee;
}

.content-coupon-reverse:hover .card-hghlght-reverse:not(:hover) {
  opacity: 0.5;
  transform: scale(0.9);
}

/* ------------ reverse------------- */
.card-no-border {
  border: 0.5px solid #f4f4f4;
}

/* --------  card hover  ------------- */
.orderImage {
  aspect-ratio: 4/2;
  object-fit: contain;
  width: 100%;
}

.img-modal-icons {
  width: 100px;
}

.img-ratio-card {
  width: 100%;
  aspect-ratio: 4/2;
}

.yellow-star {
  color: gold;
}

.border-none {
  border: none;
}

.bottom-border {
  border-bottom: 0.5px solid #eeeeee;
}
.border-radius-none {
  border-radius: 0;
}

/* ----------- table ----------- */
.table-width {
  width: 100%;
}
.td-width-half {
  width: 50%;
}
/* -------------- table --------------- */

.modal-backdrop {
  width: 100% !important;
}

.card-inner-text-div {
  padding: 0.75rem;
  padding-bottom: 3px;
  padding-top: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/style.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;AACF;;AAEA,wFAAwF;AACxF;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,2FAA2F;AAC3F;EACE,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,2FAA2F;;AAE3F,kGAAkG;;AAElG;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,kGAAkG;;AAElG;EACE,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,yCAAyC;EACzC,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,4CAA4C;EAC5C;IACE,sCAAsC;IACtC,6BAA6B;EAC/B;AACF;AACA;EACE,gBAAgB;AAClB;AACA,wCAAwC;;AAExC;EACE,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,gCAAgC;;AAEhC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,gCAAgC;;EAEhC;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA,yCAAyC;;AAEzC;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["#root {\n  padding: 0;\n}\n\nbody {\n  font-family: \"Manrope\", sans-serif;\n  width: 100%;\n  display: block !important;\n  background: white !important;\n  overflow-x: hidden;\n}\n.card {\n  padding: 0;\n}\n\n.width-full-page {\n  width: 80%;\n  /* z-index: 1; */\n}\n\n.width-full-page-product {\n  width: 70%;\n}\n\n.mini-height-div {\n  min-height: 70vh;\n  align-content: center;\n}\n\n.card-head-width {\n  width: 80%;\n}\n@media (max-width: 768px) {\n  .width-full-page {\n    width: 100%;\n    padding: 2%;\n  }\n  .width-full-page-product {\n    width: 100%;\n    padding: 2%;\n  }\n  .reverse-display {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n}\n\n/* -----------------------------  render pages style  -------------------------------- */\n.bg-green-custom {\n  background-color: #ecfff3;\n}\n.span-with-green {\n  color: #28af4b !important;\n}\n.span-with-green-mail {\n  color: #28af4b;\n  font-weight: 700;\n  font-family: \"Manrope\", sans-serif;\n}\n\n.line-span {\n  width: 100%;\n  position: relative;\n}\n.line-div {\n  width: 100%;\n  border-bottom: 1.5px solid #707070;\n  position: absolute;\n  bottom: 7px;\n}\n\n.line-div-max-length {\n  width: 100%;\n  border-bottom: 0.5px solid #707070a2;\n  position: absolute;\n  bottom: 7px;\n  max-width: 150px;\n}\n\n/* --------------------------------- Headings ------------------------------------------- */\n.heading-pages {\n  font-family: \"Poppins\", sans-serif;\n  /* line-height: 60px; */\n  font-weight: 700;\n  font-size: 30px;\n  text-align: center;\n  color: #333132;\n}\n.sub-div-headings {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 20px;\n  text-wrap: nowrap;\n}\n.sub-div-modal-headings {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 20px;\n}\n.inner-text-heading {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  color: #333132;\n}\n\n.inner-text-heading-two {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #333132;\n}\n\n.inner-text-heading-three {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #707070;\n}\n\n.inner-text-content-three-color {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #333132;\n}\n\n.inner-text-heading-four {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  color: #333132;\n}\n\n.inner-text-heading-address {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #333132;\n}\n\n/* --------------------------------- Headings ------------------------------------------- */\n\n/* ------------------------------------- inner content  ---------------------------------------- */\n\n.sub-text-pages {\n  font-size: 16px;\n  color: #333132;\n  font-weight: 700;\n  font-family: \"Manrope\", sans-serif;\n}\n.inner-text-content {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  color: #333132;\n}\n\n.inner-text-content-two {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  color: #333132;\n}\n\n.inner-text-content-three {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #333132;\n}\n\n.inner-text-content-four {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #707070;\n}\n\n.inner-text-content-five {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #333132;\n}\n\n.inner-text-content-six {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  color: #707070;\n}\n\n.inner-text-content-seven {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #333132;\n}\n\n.inner-text-content-five-font-12 {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  color: #333132;\n}\n.font-color-gray {\n  color: #747373;\n}\n\n.one-line-headings {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* ------------------------------------- inner content  ---------------------------------------- */\n\n.green-button-style {\n  background-color: #28af4b;\n  color: white;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 5px;\n}\n.green-transparnt-button-style {\n  background-color: transparent;\n  color: #28af4b;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 5px;\n  outline: 1px solid #28af4b;\n}\n\n.green-button-style:hover {\n  border: 1px solid #28af4b;\n}\n\n.list-about-us {\n  list-style-position: outside;\n}\n\n.list-about-us li {\n  padding-top: 40px;\n}\n\n.background-light-green {\n  background-color: #ecfff3;\n}\n\n.background-light-white {\n  background-color: #f9f9f9;\n}\n\n.card-howitswork {\n  border: 0.5px solid #eeeeee !important;\n  box-shadow: none !important;\n}\n\n.number-div-height {\n  height: 75px;\n}\n.card-number-head {\n  background-color: #28af4b;\n  padding: 10px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  font-size: 26px;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  border-radius: 50%;\n  color: white;\n}\n\n.accordion-custom {\n  --bs-accordion-active-color: #28af4b !important;\n  --bs-accordion-active-bg: none !important;\n  border-bottom: none;\n  --bs-accordion-btn-focus-box-shadow: none !important;\n}\n\n.product-custom-food {\n  --bs-accordion-border-width: none !important;\n  .accordion-header {\n    /* border-bottom: 1px solid #eeeeee; */\n    border-top: 1px solid #eeeeee;\n  }\n}\n.food-list .accordion-button:not(.collapsed) {\n  box-shadow: none;\n}\n/* --------  card hover  ------------- */\n\n.content-fishcard {\n  pointer-events: none;\n  transition: all 0.4s;\n  /* z-index: 1; */\n}\n\n.card-hghlght {\n  pointer-events: auto;\n  transform: scale(1);\n  transition: all 0.4s;\n  margin-top: 8px;\n  height: 100%;\n}\n\n.card-hghlght:hover {\n  opacity: 1;\n  transform: scale(1.08);\n}\n\n.content-fishcard:hover .card-hghlght:not(:hover) {\n  opacity: 0.5;\n  transform: scale(0.9);\n}\n\n/* ------------reverse ------- */\n\n.card-hghlght-reverse {\n  pointer-events: auto;\n  transform: scale(1);\n  transition: all 1s;\n  /* margin-top: 8px; */\n  height: 100%;\n  border-bottom-right-radius: 20px;\n\n  .card-body {\n    padding: 0px;\n  }\n}\n\n.card-hghlght-reverse:hover {\n  opacity: 1;\n  transform: scale(1.05);\n  box-shadow: 0 1px 2px 0 #eeeeee, 0 1.5px 5px 0 #eeeeee;\n}\n\n.content-fishcard-reverse:hover .card-hghlght-reverse:not(:hover) {\n  opacity: 0.5;\n  transform: scale(0.9);\n}\n\n.card-coupon-reverse {\n  pointer-events: auto;\n  transform: scale(1);\n  transition: all 1s;\n  height: 100%;\n  border: none;\n}\n\n.card-coupon-reverse:hover {\n  opacity: 1;\n  transform: scale(0.95);\n  box-shadow: 0 1px 2px 0 #eeeeee, 0 1.5px 5px 0 #eeeeee;\n}\n\n.content-coupon-reverse:hover .card-hghlght-reverse:not(:hover) {\n  opacity: 0.5;\n  transform: scale(0.9);\n}\n\n/* ------------ reverse------------- */\n.card-no-border {\n  border: 0.5px solid #f4f4f4;\n}\n\n/* --------  card hover  ------------- */\n.orderImage {\n  aspect-ratio: 4/2;\n  object-fit: contain;\n  width: 100%;\n}\n\n.img-modal-icons {\n  width: 100px;\n}\n\n.img-ratio-card {\n  width: 100%;\n  aspect-ratio: 4/2;\n}\n\n.yellow-star {\n  color: gold;\n}\n\n.border-none {\n  border: none;\n}\n\n.bottom-border {\n  border-bottom: 0.5px solid #eeeeee;\n}\n.border-radius-none {\n  border-radius: 0;\n}\n\n/* ----------- table ----------- */\n.table-width {\n  width: 100%;\n}\n.td-width-half {\n  width: 50%;\n}\n/* -------------- table --------------- */\n\n.modal-backdrop {\n  width: 100% !important;\n}\n\n.card-inner-text-div {\n  padding: 0.75rem;\n  padding-bottom: 3px;\n  padding-top: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
